/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/rules-of-hooks */
import { routeConfig } from "@/routes/route";
import { INavLink, INavLinkGroup } from "@fluentui/react";

export const ParseRoute = (route: routeConfig[]): INavLinkGroup => {
  let navLinkGroupArr: INavLinkGroup = { links: [] };
  let router:any = route[0].children && route[0].children?.length < 1 ? [] : route[0].children;
  router.filter((val: any) => !val.isHidden).map((item: routeConfig, index: number) => {
    const parent_link: INavLink = { name: "", url: "" };
    const child_links: INavLink[] = [];
    if (item.children !== undefined && item.children !== null) {
      item.children.filter(val => !val.isHidden).map((iitem: any, index: number) => {
        const navlink: INavLink = { url: "", key: "", name: "" };
        navlink.url = iitem.path;
        navlink.name = iitem.name;
        navlink.key = item.path + "/" + iitem.path;
        navlink.icon = iitem.icon;
        navlink.isExpanded = true;
        child_links.push(navlink);
        parent_link.links = child_links;
      });
    }
    parent_link.icon = item.icon;
    parent_link.url = item.path || "";
    // parent_link.icon = 'Brightness';
    parent_link.name = item.name;
    parent_link.key = item.path;
    parent_link.path = item.path;
    // parent_link.isExpanded = item.isExpanded == null ? true : item.isExpanded;
    navLinkGroupArr.links.push(parent_link);
  });
  return navLinkGroupArr;
};
